import axios from 'axios'
import { dateToString, DateType } from 'helpers/date-utils'
import { toggleModal } from 'components/molecules/error-modal/error-modal'
import { ConfirmationDetails, ContactInfo, Delivery, DeliveryPoint, Payment, Rental, Totals, Car } from 'store/rentals-store'
import { getCookie } from 'react-use-cookie'
import { config } from 'config/setup-cofig'

axios.interceptors.request.use(
    (config) => {
        if (getCookie('rentalId')) {
            config.headers['Authorization'] = `Bearer ${getCookie('rentalId')}`;
        }
        return config;
    }
);

axios.interceptors.response.use(undefined, (error) => {
    toggleModal(true, error.response.data?.code)
    throw error;
})

export async function init(): Promise<InitResponse> {
    return await axios.post(`${config.rentalsThinEndpoint}/init`)
}

export async function addItem(carId: string, startDate: string, endDate: string): Promise<UpdateRentalItemsResponse> {
    return await axios.put(`${config.rentalsThinEndpoint}/addItem/${carId}`, { startDate, endDate })
}

export async function removeItem(carId: string): Promise<UpdateRentalItemsResponse> {
    return await axios.put(`${config.rentalsThinEndpoint}/removeItem/${carId}`)
}

export async function updateContactInfo(contactInfo: ContactInfo): Promise<UpdateContactInfoResponse> {
    return await axios.post(`${config.rentalsThinEndpoint}/contactInfo`, contactInfo)
}

export async function updateDeliveryInfo(delivery: Delivery): Promise<UpdateDeliveryInfoResponse> {
    return await axios.post(`${config.rentalsThinEndpoint}/delivery`, delivery)
}

export async function getDeliveryPoints(carIds: string[]): Promise<DeliveryPointsResponse> {
    return await axios.get(`${config.rentalsThinEndpoint}/delivery-points`, {
        params: { carIds: carIds.join(',') }
    })
}

export interface DeliveryPointsResponse {
    data: DeliveryPoint[]
}

export async function confirmRental(payment: Payment): Promise<RentalConfirmationInfoResponse> {
    return await axios.post(`${config.rentalsThinEndpoint}/confirm`, payment)
}

export async function getAvailableCars (startDate: string, endDate: string): Promise<AvailableCarsResponse> {
    return await axios.get(`${config.rentalsThinEndpoint}/available`, {params: {startDate, endDate}})
  }
  
  export interface AvailableCarsResponse {
    data: Car[]
  }

export interface InitResponse {
    data: Rental
}

export interface UpdateRentalItemsResponse {
    data: Totals
}

export interface UpdateContactInfoResponse {
    data: ContactInfo
}

export interface UpdateDeliveryInfoResponse {
    data: Delivery
}

export interface RentalConfirmationInfoResponse {
    data: ConfirmationDetails
}